module.exports = __webpack_public_path__ + "media/images/main/staffing-benefits/pizza-express-3bc07a8e5d9a33647c18d17ba8537a89.jpg";